import { useCallback, useState } from 'react';
import {
  AuditorDateRangesPreferences,
  PreferenceKey,
  PreferenceScope,
} from '../../../data-models/preferences-v3.data-model';
import { PreferencesServiceV3 } from '../../../util/preferences-service-v3';
import { getDefaultAuditorConfig } from './auditorDateRangesConfig.schema';

export function useAuditorDateRangesConfigActions() {
  const [config, setConfig] = useState<AuditorDateRangesPreferences>(() => {
    return (
      PreferencesServiceV3.get().getPreference<AuditorDateRangesPreferences>(
        PreferenceKey.auditorDateRanges,
        PreferenceScope.ORGANIZATION
      ) ?? getDefaultAuditorConfig()
    );
  });

  const saveConfig = useCallback(
    async (newConfig: AuditorDateRangesPreferences) => {
      const updatedConfig = await PreferencesServiceV3.get().setPreference<AuditorDateRangesPreferences>(
        PreferenceKey.auditorDateRanges,
        { ...config, ...newConfig },
        PreferenceScope.ORGANIZATION
      );
      setConfig(updatedConfig.value as AuditorDateRangesPreferences);
    },
    [config]
  );

  const resetConfig = useCallback(async () => {
    const defaultConfig = getDefaultAuditorConfig();
    const updatedConfig = await PreferencesServiceV3.get().setPreference<AuditorDateRangesPreferences>(
      PreferenceKey.auditorDateRanges,
      defaultConfig,
      PreferenceScope.ORGANIZATION
    );
    setConfig(updatedConfig.value as AuditorDateRangesPreferences);
  }, []);

  return { config, saveConfig, resetConfig };
}
